import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HabilitacionContratista } from '../../types/HabilitacionContratista';

interface HabilitacionContratistaState {
    habilitaciones: HabilitacionContratista[];
    habilitacionSelected: HabilitacionContratista;
    loading: boolean;
}

export const habilitacionInitial: HabilitacionContratista = {
    id: 0,
    idEmpresaGestora: 0,
    nombreEmpresaGestora: '',
    idContratista: 0,
    nombreContratista: '',
    idTipoEstado: 0,
    nombreEstado: '',
    informacionAdicional: '',
    fechaCreacion: '',
    idUsuarioCreacion: 0,
    nombreUsuarioCreacion: '',
    apellidoUsuarioCreacion: '',
    idFlujo: 0,
    idEstadoTemporal: undefined,
};

const initialState: HabilitacionContratistaState = {
    habilitaciones: [],
    habilitacionSelected: habilitacionInitial,
    loading: false,
};

export const habilitacionContratistaSlice = createSlice({
    name: 'habilitacionContratista',
    initialState,
    reducers: {
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadDataHabilitacion: (state, data: PayloadAction<HabilitacionContratista>): void => {
            state.habilitacionSelected = data.payload;
            state.loading = false;
        },
        loadListHabilitacion: (state, data: PayloadAction<HabilitacionContratista[]>): void => {
            state.habilitaciones = data.payload;
            state.loading = false;
        },
        resetHabilitacion: (state): void => {
            state.habilitacionSelected = habilitacionInitial;
        },
    },
});

export const { isLoading, loadDataHabilitacion, loadListHabilitacion, resetHabilitacion } = habilitacionContratistaSlice.actions;
export default habilitacionContratistaSlice.reducer;
